/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_HtmlInputs */

const en_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Select a JSON file containing exported presets.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const fr_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Selectionnez un fichier JSON contenant les presets exportes.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const de_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Wählen Sie eine JSON-Datei mit exportierten Voreinstellungen aus.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const it_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Seleziona un file JSON contenente i preset esportati.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const ru_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Выберите JSON-файл, содержащий экспортированные предустановки.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const es_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Seleccione un archivo JSON que contenga los ajustes preestablecidos exportados.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const zh_cn2_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">选择包含导出预设的 JSON 文件。</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const ja_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">エクスポートされたプリセットを含むJSONファイルを選択します。</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const hi_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">निर्यातित प्रीसेट वाली JSON फ़ाइल चुनें।</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

const pt_pt2_preset_manager_import_html = /** @type {(inputs: Preset_Manager_Import_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p class="mb-3">Selecione um arquivo JSON contendo predefinições exportadas.</p><input type="file" id="presetFileInput" class="form-control" accept=".json">`)
};

/**
* | output |
* | --- |
* | "<p class=\"mb-3\">Select a JSON file containing exported presets.</p><input type=\"file\" id=\"presetFileInput\" class=\"form-control\" accept=\".json\">" |
*
* @param {Preset_Manager_Import_HtmlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_html = /** @type {((inputs?: Preset_Manager_Import_HtmlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_HtmlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_html(inputs)
	if (locale === "de") return de_preset_manager_import_html(inputs)
	if (locale === "it") return it_preset_manager_import_html(inputs)
	if (locale === "ru") return ru_preset_manager_import_html(inputs)
	if (locale === "es") return es_preset_manager_import_html(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_html(inputs)
	if (locale === "ja") return ja_preset_manager_import_html(inputs)
	if (locale === "hi") return hi_preset_manager_import_html(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_html(inputs)
	return en_preset_manager_import_html(inputs)
});